<template>
  <div class="coal-compare__wrapper">
    <div class="coal-compare__bars">
      <!-- Historic -->
      <div class="coal-compare__bar">
        <div class="coal-compare__header">
          <span class="coal-compare__scenario f-ui-1-bold">2021</span>
          <span class="coal-compare__value f-ui-1"
            >Mtce<br />{{
              (Math.floor(historicTotal / 10) * 10).toLocaleString("FR")
            }}</span
          >
        </div>
        <div
          class="coal-compare__segment background-historic"
          :style="{ height: `${(historic.advanced / max) * 100}%` }"
        >
          <span class="coal-compare__segment-label f-ui-2"
            >Advanced economies</span
          >
        </div>
        <div
          class="coal-compare__segment background-gray"
          :style="{ height: `${(historic.EMDE / max) * 100}%` }"
        >
          <span class="coal-compare__segment-label f-ui-2"
            >Other emerging market and developing economies</span
          >
        </div>
        <div
          class="coal-compare__segment background-china"
          :style="{ height: `${(historic.China / max) * 100}%` }"
        >
          <span class="coal-compare__percent f-ui-1-bold"
            >{{ ((historic.China / historicTotal) * 100).toFixed(0) }}%</span
          >
          <span class="coal-compare__segment-label f-ui-2">China</span>
        </div>
      </div>
      <!-- Future scenario -->
      <div class="coal-compare__bar">
        <div class="coal-compare__header">
          <span class="coal-compare__scenario f-ui-1-bold">{{
            scenario.name
          }}</span>
          <span class="coal-compare__value f-ui-1">{{
            (Math.floor(scenarioTotal / 10) * 10).toLocaleString("FR")
          }}</span>
        </div>
        <div
          class="coal-compare__segment background-historic"
          :style="{ height: `${(scenario.advanced / max) * 100}%` }"
        />
        <div
          class="coal-compare__segment background-gray"
          :style="{ height: `${(scenario.EMDE / max) * 100}%` }"
        />
        <div
          class="coal-compare__segment background-china"
          :style="{ height: `${(scenario.China / max) * 100}%` }"
        >
          <span class="coal-compare__percent f-ui-1-bold"
            >{{ ((scenario.China / scenarioTotal) * 100).toFixed(0) }}%</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    max: {
      type: Number,
      required: true,
    },
    historic: {
      type: Object,
      required: true,
    },
    scenario: {
      type: Object,
      required: true,
    },
  },
  computed: {
    historicTotal() {
      const { historic } = this;
      return historic.advanced + historic.EMDE + historic.China;
    },
    scenarioTotal() {
      const { scenario } = this;
      return scenario.advanced + scenario.EMDE + scenario.China;
    },
  },
};
</script>

<style scoped>
.coal-compare__wrapper {
  height: 50%;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  background: #fff;
  padding-top: 60px;
}
.coal-compare__bars {
  display: flex;
  flex: 1 0 auto;
  align-items: flex-end;
  position: relative;
}
.coal-compare__bar {
  flex: 0 0 45%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-right: 20px;
}
.coal-compare__header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.coal-compare__segment {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  position: relative;
  transition: height 0.3s ease;
}
.coal-compare__segment-label {
  width: 80%;
  text-align: center;
}
.coal-compare__percent {
  position: absolute;
  top: 4px;
  left: 8px;
}
.background-china {
  background: #e63223;
  color: #efe23b;
}
/* Responsive rules */
@media screen and (max-width: 729px) {
  .coal-compare__segment-label {
    font-size: 11px;
    line-height: 13px;
  }
}
</style>